export const STORE_INJECTION_KEY = Symbol('storeContextKey')
